import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';

class ReadMore extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      expanded: false,
      truncated: false,
    };

    this.handleTruncate = this.handleTruncate.bind(this);
    this.toggleLines = this.toggleLines.bind(this);
  }

  handleTruncate(truncated) {
    const { truncated: lastTruncated } = this.state;
    if (truncated !== lastTruncated) {
      this.setState({
        truncated,
      });
    }
  }

  toggleLines(event) {
    const { expanded } = this.state;
    event.preventDefault();
    this.setState({
      expanded: !expanded,
    });
  }

  render() {
    const { theme, children, moreText, lessText, lines, className } = this.props;
    const { expanded, truncated } = this.state;

    return (
      <span className={className}>
        <Truncate
          lines={!expanded && lines}
          ellipsis={
            <span className={theme.buttonContainer}>
              {'... '}
              <a href="#" className={theme.button} onClick={this.toggleLines}>
                {moreText}
              </a>
            </span>
          }
          width={0}
          onTruncate={this.handleTruncate}
        >
          <span className={theme.children}>{children}</span>
          {!truncated && expanded && (
            <span className={theme.buttonContainer}>
              <a href="#" className={theme.button} onClick={this.toggleLines}>
                {lessText}
              </a>
            </span>
          )}
        </Truncate>
      </span>
    );
  }
}

ReadMore.defaultProps = {
  lines: 3,
  className: '',
};

ReadMore.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  lines: PropTypes.number,
  moreText: PropTypes.string.isRequired,
  lessText: PropTypes.string.isRequired,
  theme: PropTypes.shape({}).isRequired,
};

export default ReadMore;
